export { default } from './StockPagePagination';
